import { createSelector } from 'reselect';
import CarrierMailRegistrationDeviceDeliveryCarrierPerformanceColumns from '../../containers/CarrierMailRegistrationDeviceDeliveryCarrierPerformanceColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state
  // eslint-disable-next-line max-len
  .reporting.CARRIER_MAIL_REGISTRATION_DEVICE_DELIVERY_CARRIER_PERFORMANCE.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.CARRIER_MAIL_REGISTRATION_DEVICE_DELIVERY_CARRIER_PERFORMANCE.isLoading;

export const getData =
  ReportDefinitions.CARRIER_MAIL_REGISTRATION_DEVICE_DELIVERY_CARRIER_PERFORMANCE.getDataFunction();

export const getColumns = createSelector(
  getData,
  state => state.reporting.CARRIER_MAIL_REGISTRATION_DEVICE_DELIVERY_CARRIER_PERFORMANCE.requestParams,
  CarrierMailRegistrationDeviceDeliveryCarrierPerformanceColumns,
);
